/**
 * @generated SignedSource<<0fa4484d77efbe41ffa4639fd3087bd6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type reportCategories_reportsOverviewPage$data = {
  readonly jira?: {
    readonly jiraBoard: {
      readonly reportCategories?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly name: string;
            readonly " $fragmentSpreads": FragmentRefs<"reportCategory_reportsOverviewPage">;
          } | null | undefined;
        } | null | undefined>;
      };
    };
  };
  readonly jira_projectByIdOrKey?: {
    readonly reportCategories: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly name: string;
          readonly " $fragmentSpreads": FragmentRefs<"reportCategory_reportsOverviewPage">;
        } | null | undefined;
      } | null | undefined>;
    };
  };
  readonly " $fragmentType": "reportCategories_reportsOverviewPage";
};
export type reportCategories_reportsOverviewPage$key = {
  readonly " $data"?: reportCategories_reportsOverviewPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"reportCategories_reportsOverviewPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "name"
},
v1 = {
  "kind": "FragmentSpread",
  "name": "reportCategory_reportsOverviewPage"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "boardId"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "isBoardContext"
    },
    {
      "kind": "RootArgument",
      "name": "projectKey"
    }
  ],
  "kind": "Fragment",
  "name": "reportCategories_reportsOverviewPage",
  "selections": [
    {
      "condition": "isBoardContext",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Variable",
                "name": "idOrKey",
                "variableName": "projectKey"
              }
            ],
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jira_projectByIdOrKey",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "concreteType": "JiraReportCategoryConnection",
                  "kind": "LinkedField",
                  "name": "reportCategories",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "concreteType": "JiraReportCategoryEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraReportCategoryNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v0/*: any*/),
                                "action": "THROW",
                                "path": "jira_projectByIdOrKey.reportCategories.edges.node.name"
                              },
                              (v1/*: any*/)
                            ]
                          }
                        ]
                      },
                      "action": "THROW",
                      "path": "jira_projectByIdOrKey.reportCategories.edges"
                    }
                  ]
                },
                "action": "THROW",
                "path": "jira_projectByIdOrKey.reportCategories"
              }
            ]
          },
          "action": "THROW",
          "path": "jira_projectByIdOrKey"
        }
      ]
    },
    {
      "condition": "isBoardContext",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "id",
                      "variableName": "boardId"
                    }
                  ],
                  "kind": "LinkedField",
                  "name": "jiraBoard",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "JiraReportCategoryConnection",
                            "kind": "LinkedField",
                            "name": "reportCategories",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "concreteType": "JiraReportCategoryEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "concreteType": "JiraReportCategoryNode",
                                      "kind": "LinkedField",
                                      "name": "node",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "kind": "RequiredField",
                                          "field": (v0/*: any*/),
                                          "action": "THROW",
                                          "path": "jira.jiraBoard.reportCategories.edges.node.name"
                                        },
                                        (v1/*: any*/)
                                      ]
                                    }
                                  ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraBoard.reportCategories.edges"
                              }
                            ]
                          },
                          "action": "THROW",
                          "path": "jira.jiraBoard.reportCategories"
                        }
                      ],
                      "type": "JiraBoard"
                    }
                  ]
                },
                "action": "THROW",
                "path": "jira.jiraBoard"
              }
            ]
          },
          "action": "THROW",
          "path": "jira"
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "fde9d2b663ddf06f066a550e718e4bdd";

export default node;
